<template>
    <div>
        <Pane title="重新校审" :showRemarks="false">
            <template>
                <span>重新发起校审流程，上传修改版成果附件</span>
            </template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form
                    :form="form"
                    :label-col="{ span: 8 }"
                    :wrapper-col="{ span: 12 }"
                    :colon="false"
                >
                    <div class="title" style="margin-top: 0">基本信息</div>
                    <div class="wrapper">
                        <a-row>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="项目名称">
                                    <a-input :disabled="true" v-decorator="['projectName']" />
                                </a-form-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="项目阶段">
                                    <DataDictFinder dictType="cosys.designPhase" :dictValue="detail?.phaseCode" />
                                </a-form-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="校审编号">
                                    <a-input :disabled="true" v-decorator="['auditNo']" />
                                </a-form-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="设计编号">
                                    <a-input :disabled="true" v-decorator="['designNo']" />
                                </a-form-item>
                            </a-col>
                            <a-col :lg="12" :md="12" :sm="24">
                                <a-form-item label="专业名称">
                                    <a-input :disabled="true" v-decorator="['majorName']" />
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="title">成果附件</div>
                    <div class="wrapper">
                        <a-row :gutter="16" class="form-panel">
                            <a-col :lg="24" :md="24" :sm="24">
                                <a-form-item label="关联成果" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
                                    <div style="background-color: #fff">
                                        <a-table
                                            :data-source="results"
                                            :columns="resultColumns"
                                            :pagination="false"
                                            row-key="id"
                                            bordered
                                            :expandedRowKeys="expandedRowKeys"
                                            @expand="onExpand"
                                        >
                                            <template slot="expandedRowRender" slot-scope="record">
                                                <a-table
                                                    :data-source="record.attachment"
                                                    :columns="attachmentColumns"
                                                    :pagination="false"
                                                    row-key="id"
                                                    bordered
                                                    size="small"
                                                >
                                                </a-table>
                                            </template>
                                            <template slot="action" slot-scope="text, record">
                                                <a-button type="link" @click="uploadAttachment(record)">替换</a-button>
                                            </template>
                                        </a-table>
                                    </div>
                                </a-form-item>
                            </a-col>
                            <a-col :lg="24" :md="24" :sm="24" v-if="showReplacementTable">
                                <a-form-item label="替换成果" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }" :validate-status="showRequiredError ? 'error' : ''" :help="showRequiredError ? '请上传替换成果附件' : ''">
                                    <div style="background-color: #fff">
                                        <div v-for="(group, groupIndex) in replacementGroups" :key="group.resultId" style="margin-bottom: 16px;">
                                            <div style="font-weight: bold; margin-bottom: 8px; padding: 8px; background: #fafafa; border: 1px solid #e8e8e8; border-radius: 4px 4px 0 0;">
                                                {{ group.resultName }}-{{ group.resultNo }}
                                            </div>
                                            <a-button type="dashed" style="width: 100%; margin-bottom: 8px" @click="triggeruploadOssFiles(groupIndex)" :disabled="isUploading">
                                                上传附件
                                            </a-button>
                                            <div v-if="showUploadProgress && groupIndex === currentGroupIndex" style="margin-bottom: 8px;">
                                                <div style="font-size: 12px; color: #666; margin-bottom: 4px;">{{ uploadOssFileName }}</div>
                                                <a-progress :percent="uploadProgress" :show-info="true" />
                                            </div>
                                            <a-table bordered :dataSource="group.files" :pagination="false" row-key="tempId" :class="{ 'required-error': showRequiredError && group.files.length === 0 }">
                                                <a-table-column title="名称">
                                                    <template slot-scope="text, record">
                                                        {{ record.name }}
                                                    </template>
                                                </a-table-column>
                                                <a-table-column title="附件类型" align="center" width="160">
                                                    <template slot-scope="text, record">
                                                        <a-select
                                                            :value="record.type"
                                                            style="width: 120px"
                                                            placeholder="请选择"
                                                            @change="(val) => { record.type = val; record.isSign = val === 'blueprint'; }"
                                                        >
                                                            <a-select-option
                                                                v-for="opt in attachmentTypeOptions"
                                                                :key="opt.value"
                                                                :value="opt.value"
                                                            >
                                                                {{ opt.label }}
                                                            </a-select-option>
                                                        </a-select>
                                                    </template>
                                                </a-table-column>
                                                <a-table-column title="是否签章" align="center" width="100">
                                                    <template slot-scope="text, record">
                                                        <a-switch
                                                            :checked="record.isSign"
                                                            @change="(val) => { record.isSign = val }"
                                                        />
                                                    </template>
                                                </a-table-column>
                                                <a-table-column title="操作" align="center">
                                                    <template slot-scope="text, record, fileIndex">
                                                        <a href="#" @click.prevent="deleteFile(groupIndex, fileIndex)" class="danger">删除</a>
                                                    </template>
                                                </a-table-column>
                                            </a-table>
                                        </div>
                                    </div>
                                </a-form-item>
                            </a-col>
                        </a-row>

                    </div>

                    <div class="title">人员选择</div>
                    <div class="wrapper">
                        <a-row>
                            <a-col :span="12">
                                <a-form-item label="设计人" :required="true">
                                    <a-select mode="multiple" v-model="selectedDesigner" placeholder="请选择设计人" style="width: 100%" @change="handleDesignerChange">
                                        <a-select-option v-for="item in designerOptions" :key="item.name" :value="item.name">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="复核人" :required="true" extra="(选一人)">
                                    <a-select v-model="selectedReviewer" placeholder="请选择复核人" style="width: 100%" @change="handleReviewerChange">
                                        <a-select-option v-for="item in reviewerOptions" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="审核人" :required="true" extra="(选一人)">
                                    <a-select v-model="selectedAuditor" placeholder="请选择审核人" style="width: 100%" @change="handleAuditorChange">
                                        <a-select-option v-for="item in auditorOptions" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                            <a-col :span="12">
                                <a-form-item label="审定人" extra="(选一人)">
                                    <a-select v-model="selectedApprover" placeholder="请选择审定人" style="width: 100%" @change="handleApproverChange">
                                        <a-select-option v-for="item in approverOptions" :key="item.id" :value="item.name">{{ item.name }}</a-select-option>
                                    </a-select>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </div>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
        <input ref="fileInput" type="file" multiple @change="onFileChange" style="display: none" />
    </div>
</template>

<script>
import { fetchDesignResultAuditDetail, resubmitDesignResult, fetchPrjTaskPhaseSummary, uploadDesignResultAuditMarkup } from "@/api/project-execute/result";
import { fetchSimplePlanPersonnel, getDesignPlanPersonnel } from "@/api/personnel";
import { uploadOssFile } from "@/api/upload";
import { debounce } from 'lodash';
import { mapMutations } from "vuex";

export default {
    name: "reReview",
    components: { },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            submitting: false,
            detail: null,
            auditId: "",
            taskId: "",
            instanceId: "",
            results: [],
            expandedRowKeys: [],
            resultColumns: [
                { title: "成果名称", dataIndex: "resultName", key: "resultName" },
                { title: "成果编号", dataIndex: "resultNo", key: "resultNo" },
                { title: "提交人", dataIndex: "submitUserName", key: "submitUserName" },
                { title: "提交时间", dataIndex: "createAt", key: "createAt" },
                { title: "操作", key: "action", scopedSlots: { customRender: "action" } },
            ],
            attachmentColumns: [
                { title: "附件名称", dataIndex: "name", key: "name" },
                { title: "附件类型", dataIndex: "type", key: "type",
                    customRender: (value) => {
                        const typeMap = {
                            'calc': '计算书',
                            'spec': '说明书',
                            'blueprint': '图纸',
                            'text': '文本',
                        };
                        return typeMap[value] || value;
                    }
                },
                { title: "是否签章", dataIndex: "isSign", key: "isSign",
                    customRender: (value) => value ? '是' : '否'
                },
            ],
            replacementGroups: [], // 按成果分组的替换文件列表
            attachmentTypeOptions: [
                { value: 'calc', label: '计算书' },
                { value: 'spec', label: '说明书' },
                { value: 'blueprint', label: '图纸' },
                { value: 'text', label: '文本' },
            ],

            currentGroupIndex: null, // 当前选择文件的成果组索引
            showRequiredError: false,
            isUploading: false,
            uploadProgress: 0,
            uploadOssFileName: '',
            phaseSummary: null,
            selectedDesigner: [],
            selectedReviewer: undefined,
            selectedAuditor: undefined,
            selectedApprover: undefined,
            designerOptions: [],
            reviewerOptions: [],
            auditorOptions: [],
            approverOptions: [],
        };
    },
    computed: {
        showReplacementTable() {
            return this.replacementGroups.length > 0;
        },
        showUploadProgress() {
            return this.uploadProgress > 0 && this.uploadProgress <= 100;
        },
    },
    created() {
        // 创建防抖版本的提交函数
        this.debouncedSubmitReview = debounce(this.doSubmitReview, 1000, { leading: true, trailing: false });
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.auditId = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.auditId = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.auditId) {
            this.fetchDetail(this.auditId);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),

        fetchDetail(id) {
            this.loading = true;
            fetchDesignResultAuditDetail(id)
                .then((res) => {
                    this.detail = res;
                    this.results = res.results || [];
                    this.replacementGroups = [];

                    this.form.setFieldsValue({
                        projectName: res.projectName || "",
                        auditNo: res.auditNo || "",
                        designNo: res.designNo || "",
                        majorName: res.majorName || "",
                    });
                    if (res.phaseId) {
                        fetchPrjTaskPhaseSummary(res.phaseId).then((summary) => {
                            this.phaseSummary = summary;
                        }).catch(() => {
                            console.warn('获取阶段概要失败');
                        }).finally(() => {
                            this.fetchPersonnelOptions(res);
                        });
                    } else {
                        this.fetchPersonnelOptions(res);
                    }
                })
                .catch(() => {
                    this.$message.error("获取校审详情失败");
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        uploadAttachment(record) {
            // 检查是否已存在该成果的替换组
            const existingGroup = this.replacementGroups.find(g => g.resultId === record.id);
            if (!existingGroup) {
                // 添加新的替换组
                this.replacementGroups.push({
                    resultId: record.id,
                    resultName: record.resultName,
                    resultNo: record.resultNo,
                    files: [],
                });
            }
        },

        onExpand(expanded, record) {
            if (expanded) {
                this.expandedRowKeys = [record.id];
            } else {
                this.expandedRowKeys = this.expandedRowKeys.filter(key => key !== record.id);
            }
        },

        triggeruploadOssFiles(groupIndex) {
            this.currentGroupIndex = groupIndex;
            this.$refs.fileInput.click();
        },

        onFileChange(e) {
            const files = e.target.files;
            if (!files.length) return;
            if (this.currentGroupIndex === null) return;

            const group = this.replacementGroups[this.currentGroupIndex];
            if (!group) return;

            this.isUploading = true;
            this.uploadProgress = 0;

            const names = Array.from(files).map(f => f.name);
            this.uploadOssFileName = names.join('; ');

            const data = new FormData();
            data.append("moduleName", "project");
            for (let i = 0; i < files.length; i++) {
                data.append("files", files[i]);
            }

            uploadOssFile(data, (progressEvent) => {
                const pct = Number(
                    (progressEvent.loaded / progressEvent.total * 100).toFixed(2)
                );
                this.uploadProgress = Math.min(pct, 99);
            })
                .then((res) => {
                    this.uploadProgress = 100;
                    if (Array.isArray(res)) {
                        let tempIdCounter = group.files.length;
                        res.forEach((item) => {
                            group.files.push({
                                tempId: `uploaded_${Date.now()}_${tempIdCounter++}`,
                                id: item.id,
                                name: item.name,
                                completePath: item.completePath,
                                type: '',
                                isSign: false,
                                resultId: group.resultId,
                            });
                        });
                    }
                })
                .catch(() => {
                    this.$message.error("文件上传失败");
                })
                .finally(() => {
                    this.isUploading = false;
                    this.currentGroupIndex = null;
                    e.target.value = null;
                    setTimeout(() => { this.uploadProgress = 0; }, 1000);
                });
        },

        deleteFile(groupIndex, fileIndex) {
            const group = this.replacementGroups[groupIndex];
            if (!group) return;
            group.files.splice(fileIndex, 1);
            // 如果该组没有文件了，删除整个组
            if (group.files.length === 0) {
                this.replacementGroups.splice(groupIndex, 1);
            }
        },

        enterAnnotation() {
            const url = this.$router.resolve({
                name: "annotation",
                query: {
                    taskId: this.taskId,
                    instanceId: this.instanceId,
                    auditId: this.auditId,
                    projectName: (this.detail && this.detail.projectName) || "",
                    viewMode: "view",
                },
            }).href;
            window.open(url, "_blank");
        },

        submitReview() {
            // 调用防抖版本的提交函数
            this.debouncedSubmitReview();
        },

        async doSubmitReview() {
            this.showRequiredError = false;
            if (this.isUploading) {
                this.$message.warning("文件上传中，请稍后");
                return;
            }
            const allFiles = this.replacementGroups.flatMap(g => g.files);
            if (allFiles.length === 0) {
                this.showRequiredError = true;
                this.$message.error("请上传替换成果附件");
                return;
            }
            const filesWithoutType = allFiles.filter(f => !f.type);
            if (filesWithoutType.length > 0) {
                this.$message.error("请为所有附件选择附件类型");
                return;
            }
            if (!this.selectedDesigner || this.selectedDesigner.length === 0) {
                this.$message.error("请选择设计人");
                return;
            }
            if (!this.selectedReviewer) {
                this.$message.error("请选择复核人");
                return;
            }
            if (!this.selectedAuditor) {
                this.$message.error("请选择审核人");
                return;
            }


            this.submitting = true;
            const hide = this.$message.loading("正在提交...", 0);

            try {
                const getOptId = (options, name) => {
                    const opt = options.find(o => o.name === name);
                    return opt ? opt.id : '';
                };
                const resultIds = [...new Set(allFiles.map(item => item.resultId).filter(Boolean))];

                // 第一步：上传校审批注附件
                const markupData = {
                    auditId: this.auditId,
                    resultAttachments: this.replacementGroups.map(group => ({
                        attachment: JSON.stringify(group.files.map(item => ({
                            id: item.id,
                            name: item.name,
                            type: item.type || '',
                            isSign: item.isSign || false,
                        }))),
                        resultId: group.resultId,
                    })),
                };
                await uploadDesignResultAuditMarkup(markupData);

                // 第二步：重新提交审批
                await resubmitDesignResult({
                    id: this.auditId,
                    resultId: resultIds[0],
                    resultIds: resultIds,
                    phaseId: this.detail.phaseId,
                    phaseCode: this.detail.phaseCode,
                    wbsId: this.detail.wbsId,
                    wbsFullId: this.detail.wbsFullId,
                    auditNo: this.detail.auditNo,
                    designerId: this.selectedDesigner.map(n => getOptId(this.designerOptions, n)).filter(Boolean).join(','),
                    designerName: this.selectedDesigner.join(','),
                    reviewerId: getOptId(this.reviewerOptions, this.selectedReviewer),
                    reviewerName: this.selectedReviewer || "",
                    auditorId: getOptId(this.auditorOptions, this.selectedAuditor),
                    auditorName: this.selectedAuditor || "",
                    approverId: getOptId(this.approverOptions, this.selectedApprover),
                    approverName: this.selectedApprover || "",
                    attachment: JSON.stringify(allFiles.map(item => ({
                        id: item.id,
                        name: item.name,
                        type: item.type || '',
                        isSign: item.isSign || false,
                        resultId: item.resultId,
                    }))),
                });

                hide();
                this.$message.success("提交成功");
                this.$close(this.$route.path, "/approval/task");
            } catch (error) {
                hide();
                this.$message.error("提交失败");
            } finally {
                this.submitting = false;
            }
        },

        goBack() {
            this.$close(this.$route.path);
        },

        async fetchPersonnelOptions(detail) {
            const buildOptions = (namesStr, idsStr) => {
                const names = (namesStr || '').split(',').filter(Boolean);
                const ids = (idsStr || '').split(',').filter(Boolean);
                return names.map((name, i) => ({ name, id: ids[i] || '' }));
            };

            try {
                if (this.phaseSummary?.majors) {
                    const isSimple = this.phaseSummary?.prjCategory === 'simple';
                    const res = isSimple
                        ? await fetchSimplePlanPersonnel({ majorCode: this.phaseSummary.majors, phaseId: this.phaseSummary.id })
                        : await getDesignPlanPersonnel({ majorCode: this.phaseSummary.majors, phaseId: this.phaseSummary.id });
                    if (res && res.majorPersonnels) {
                        const fromMajor = res.majorPersonnels.find(m => m.majorName === detail.majorName);
                        if (fromMajor) {
                            this.designerOptions = buildOptions(fromMajor.designerNames, fromMajor.designerIds);
                            this.reviewerOptions = buildOptions(fromMajor.reviewerNames, fromMajor.reviewerIds);
                            this.auditorOptions = buildOptions(fromMajor.auditorNames, fromMajor.auditorIds);
                            this.approverOptions = buildOptions(fromMajor.approverNames, fromMajor.approverIds);
                        }
                    }
                }
            } catch (e) {
                console.warn('获取人员信息失败', e);
            }

            if (this.designerOptions.length === 0 && detail.designerName) {
                this.designerOptions = buildOptions(detail.designerName, detail.designerId || '');
            }
            if (this.reviewerOptions.length === 0 && detail.reviewerName) {
                this.reviewerOptions = buildOptions(detail.reviewerName, detail.reviewerId || '');
            }
            if (this.auditorOptions.length === 0 && detail.auditorName) {
                this.auditorOptions = buildOptions(detail.auditorName, detail.auditorId || '');
            }
            if (this.approverOptions.length === 0 && detail.approverName) {
                this.approverOptions = buildOptions(detail.approverName, detail.approverId || '');
            }

            this.selectedDesigner = (detail.designerName || '').split(',').filter(Boolean).filter(n => this.designerOptions.some(o => o.name === n));
            this.selectedReviewer = (detail.reviewerName || '').split(',').filter(Boolean).find(n => this.reviewerOptions.some(o => o.name === n));
            this.selectedAuditor = (detail.auditorName || '').split(',').filter(Boolean).find(n => this.auditorOptions.some(o => o.name === n));
            this.selectedApprover = (detail.approverName || '').split(',').filter(Boolean).find(n => this.approverOptions.some(o => o.name === n));
        },

        handleDesignerChange(value) {
            this.selectedDesigner = value;
        },

        handleReviewerChange(value) {
            this.selectedReviewer = value;
        },

        handleAuditorChange(value) {
            this.selectedAuditor = value;
        },

        handleApproverChange(value) {
            this.selectedApprover = value;
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.wrapper {
    background-color: #f9f9f9;
    padding-top: 24px;
    padding-bottom: 8px;
}

.title {
    font-weight: bold;
    font-size: 17px;
    margin: 12px 0;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}

.required-error {
    border: 1px solid #ff4d4f !important;
    border-radius: 4px;
}

.file-list {
    padding: 8px 12px;
}

.file-item {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    margin: 4px;
    background: #fff;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
}
</style>
